import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Dropdown } from 'primeng/dropdown';
import { environment } from '../../../../environments/environment';
import { RegistroService } from '../../../services/auth/registro.service';

@Component({
  selector: 'app-migration-user',
  templateUrl: './migration-user.component.html',
  styleUrls: ['./migration-user.component.css']
})
export class MigrationUserComponent implements OnInit {
  /**
   * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
   *
   * code: Código del mensaje de respuesta a mostrar en la función.
   * titulo: Título a enviar; solo si se recibe con la respuesta del endpoint.
   * detalle: Detalle a enviar; solo si se recibe con la respuesta del endpoint.
   */
   loginForm: FormGroup;
   registroForm: FormGroup;
    visibleSpinner = false;
    pass: string;
    regExpNit: string = null;
    minLengthPass: number = null;
    generos: any = [];
    tratamientos: any = [];
    // Variables para mensaje
    code: any;
    titulo: any;
    detalle: any;

    dataUser: any = {};
    hasDataUser = false;
    savedUser: any;
    finish = false;
    mailUser: string;
    customMask: string = "9999-999999-999-9";

    checkConditions: boolean = false;
    displayModalConditions = false;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private registroService: RegistroService) {
                    this.cargarCatalogos();
    }

    ngOnInit(): void {
        this.loginForm = this.formBuilder.group({
            user: ['', [Validators.required]],
            pass: ['', [Validators.required]]
        });

        // Se verifica si existe algún mensaje pendiente de mostrar
        if (localStorage.getItem('msgbo')) {
          const type = localStorage.getItem('msgty');
          const title = localStorage.getItem('msgti');
          const body = localStorage.getItem('msgbo');

          setTimeout(() => {
            this.code = type;
            this.titulo = title;
            this.detalle = body;

            setTimeout(() => {
              localStorage.removeItem('msgty');
              localStorage.removeItem('msgti');
              localStorage.removeItem('msgbo');
            }, 1000);
          }, 500);
        }
    }

    validateLoginPel(): void {
        localStorage.clear();
        this.visibleSpinner = true;
        this.code = '';
        this.detalle = '';
        
        let user = this.loginForm.value.user;
        /*const userOnlyNums = user.match(/\d/g).join("");
        if(userOnlyNums.length == 9){
            user = user.slice(0, -2);
        }*/

        this.registroService.validateLogInPortalEnLinea(user, this.loginForm.value.pass)
            .subscribe((res: any) => {
                this.visibleSpinner = false;

                if (res.success) {
                    this.dataUser = res.data.data;
                    this.hasDataUser = true;
                    this.savedUser = { user, pass: this.loginForm.value.pass };
                    
                    this.registroForm = this.formBuilder.group({
                        correo: [this.dataUser.emailsContacto, [Validators.required]],
                        genero: [(this.dataUser.genero) ? this.generos.filter(x => x.value === this.dataUser.genero)[0].label : '', [Validators.required]],
                        tratamiento: ['', [Validators.required]],
                    });
                } else {
                    let errores = '';
                    this.visibleSpinner = false;

                    if (res.data.message === 'Ver errores en extras') {
                        if (res.data.extra.length > 1) {
                            errores += '<ul>';
                            errores += '<li>' + res.data.extra.join('</li><li>') + '</li>';
                            errores += '</ul>';
                        } else {
                            errores = res.data.extra[0];
                        }
                    } else {
                        errores = res.data.message;
                    }
                    this.code = 'login.warn.15';
                    this.detalle = errores;
                }
            }, error => {
                this.visibleSpinner = false;
                this.code = 'login.error.default';
                this.detalle = error;
            });
    }

    showModal(event = null): void {
        this.displayModalConditions = true;
        if(event){
          event.preventDefault();
          event.stopPropagation();
        }
      }
  
      changeConditions(): void{
        this.checkConditions = !this.checkConditions;
      }

    confirmarLoginPel(): void {
    
        localStorage.clear();
        this.visibleSpinner = true;
        this.code = '';
        this.detalle = '';

        const parametros = {
            usuario: this.savedUser.user,
            pass: this.savedUser.pass,
            correo: this.registroForm.value.correo,
            genero: this.generos.filter(x => x.label === this.registroForm.value.genero)[0].value,
            tratamiento: this.registroForm.value.tratamiento,
        };
        
        const checkConditions = this.checkConditions;
        if(!checkConditions){
          this.visibleSpinner = false;
          this.code = 'registro.warn.conditions';
          setTimeout(() => this.code = null, 500);
          return;
        }

        this.registroService.confirmarLogInPortalEnLinea(parametros)
            .subscribe((res: any) => {
                this.visibleSpinner = false;

                if (res.success) {
                    this.finish = true;
                    this.mailUser = parametros.correo;
                    sessionStorage.setItem('temp_mail_register', parametros.correo); 
                } else {
                    let errores = '';
                    this.visibleSpinner = false;

                    if (res.data.message === 'Ver errores en extras') {
                        if (res.data.extra.length > 1) {
                            errores += '<ul>';
                            errores += '<li>' + res.data.extra.join('</li><li>') + '</li>';
                            errores += '</ul>';
                        } else {
                            errores = res.data.extra[0];
                        }
                    } else {
                        errores = res.data.message;
                    }
                    this.code = 'login.warn.15';
                    this.detalle = errores;
                }
            }, error => {
                this.visibleSpinner = false;
                this.code = 'login.error.default';
                this.detalle = error;
            });
    }

    cargarCatalogos(): void {
        this.registroService.getCatalogos().subscribe((res: any) => {
         
            /**
             * Para llevar los datos al listbox de tipo de persona.
             */
            const generoData = res.data.generos;
            generoData.map((p, key) => {
                const item = {
                    label: p.nombre,
                    value: p.codigo,

                };
                this.generos.push(item);
            });
            /**
             * Para llevar los datos al listbox de tratamiento.
             */
            const tratamientoData = res.data.tratamientos;
            tratamientoData.map((p, key) => {
                const item = {
                    label: p.nombre,
                    value: p.id,

                };
                this.tratamientos.push(item);
                this.visibleSpinner = false;
            });
        });

    }
}

